import { getChargerIdsForHost, getHostById, getInitialData } from "../authAPI";
import { loadTransactions } from "./loadTransactions";

const handleGetChargers = async (id) => {
  try {
    const response = await getChargerIdsForHost(id);
    const { chargerIds, hostIds, locationIds } = response;
    // return data;
    // console.log(`${id} : ${chargerIds?.length}: ${chargerIds}`);
    const trans = await loadTransactions(chargerIds);
    // console.log(`${id}: ${trans.length} ${trans}`);
    return { noOfCharger: chargerIds?.length, noOfTrans: trans?.length };
  } catch (err) {
    if (err.isErr) {
      console.log("Error getting the Transaction ", err.msg);
      console.log("Problem: ", err.problem);
    } else {
      console.log("Unexpected Error: ", err);
    }
    return err;
  }
};

/**
 * Makes a call to get the host
 * @param {string} hostIds - to get the host valid "id" or "all"
 * @returns - returns location data,no
 */
export const loadHost = async (hostIds, isHost = true) => {
  try {
    let formatHostData = [];
    await Promise.all(
      hostIds.map(async (item) => {
        try {
          const data = await getHostById(item);
          if (isHost) {
            if (data?.role === "Host" || data?.role === "Admin") {
              const { noOfCharger, noOfTrans } = await handleGetChargers(item);
              console.log("data: formatHostData ", data);
              formatHostData.push({ ...data, noOfTrans, noOfCharger, password: "" });
            }
          }else{
            if(data?.role ==="Tech"){
               formatHostData.push({ ...data, password: "" });
            }
          }
        } catch (err) {
          console.log("Error getting the host", err.msg || err);
        }
      })
    );
    // const chargerIds = await getInitialData();
    // let formatHostData = [];

    // formatHostData = response?.map((hostItem) => {
    //   return {
    //     id: hostItem?._id,
    //     email: hostItem?.email,
    //     address: hostItem?.address,
    //     phoneNumber: hostItem?.phoneNumber,
    //     name: hostItem?.name,
    //     role: hostItem?.role,
    //     type: hostItem?.type,
    //   };
    // });

    console.log("formatHostData: ", formatHostData);
    // formatHostData?.length > 0 && formatHostData.sort((a, b) => a.id.localeCompare(b.id));
    return formatHostData;
  } catch (err) {
    console.log("Error getting the host", err.msg || err);
  }
};
